import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  root: {
    paddingBottom: '4px',
    '& .MuiTypography-button': {
      paddingTop: '2px',
      fontSize: '0.64rem',
    },
  },
}));

export default useStyles;
